import {RefObject, useEffect} from 'react';

/**
 * Colors the installed window's title bar (and the strip behind its controls)
 * like the page behind it, instead of the site's Dropbox blue `theme-color`,
 * so the bar reads as part of the window. Restores the site's color on unmount.
 */
export const useTitleBarColor = (ref: RefObject<HTMLElement | null>) => {
  useEffect(() => {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    if (!meta || !ref.current) return;
    const original = meta.content;
    meta.content = getComputedStyle(ref.current).backgroundColor;
    return () => {
      meta.content = original;
    };
  }, [ref]);
};
